import WavyBackground from '@gc-bridge/assets/images/wavy-background_shared.png';
import { LinkButton } from '@gc-bridge/components/Button/Link';
import { Logout as LogoutIcon } from '@mui/icons-material';
import { alpha, Avatar, Box, styled, Typography } from '@mui/material';

const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  backgroundImage: `url(${WavyBackground})`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
});

const StyledAvatar = styled(Avatar)(({ theme: { palette } }) => ({
  margin: '30px',
  width: '172px',
  height: '172px',
  backgroundColor: alpha(palette.secondary.main, 0.08),
}));

const StyledLogoutIcon = styled(LogoutIcon)(({ theme: { palette } }) => ({
  width: '88px',
  height: '88px',
  color: palette.primary.main,
  transform: 'rotate(180deg)',
}));

const StyledText = styled(Typography)(({ theme: { palette } }) => ({
  color: palette.primary.main,
  fontSize: '34px',
  letterSpacing: '0.25px',
  lineHeight: '48px',
  marginBottom: '10px',
}));

const StyledSecondaryText = styled(Typography)(({ theme: { palette } }) => ({
  color: palette.secondary.main,
  fontSize: '24px',
  lineHeight: '32px',
  marginBottom: '20px',
}));

export function Logout() {
  return (
    <Container>
      <StyledAvatar>
        <StyledLogoutIcon />
      </StyledAvatar>
      <StyledText>You have successfully logged out.</StyledText>
      <StyledSecondaryText>
        You can login again using the button below.
      </StyledSecondaryText>
      <LinkButton label="Login" url="/" />
    </Container>
  );
}
